import { PipeTransform, Pipe } from '@angular/core';
import { LanguageModel } from './language.model';

@Pipe({ name: 'activeLanguage', pure: false })
export class ActiveLanguagePipe implements PipeTransform {
  transform(availableLanguages: LanguageModel[]): LanguageModel {
    return availableLanguages.find(s => s.isActive);
  }
}
